import BannerImg from "../images/banner-girl.png";
import BannerImg1 from "../images/Banner3-img.png";
import BannerImgmbl from "../images/Ipad-banner2-img.png";
import BannerImgmbl3 from "../images/Mobile-Banner3-img.png";
import Form from "./form";
import Logo from "../images/logo-lakme.png";
import Add from "../images/add.png";
import Edit from "../images/edit.png";
import Delete from "../images/delete.png";
import lock from "../images/lock.png";
import { Component } from "react";
import CropSection from "./cropInput";
import $ from "jquery";
import Slider from "react-slick";
import Bannerimg11 from "../images/banner-bg.jpg"
import Bannerimg2 from "../images/Banner2-bg.png"
import Bannerimg3 from "../images/Banner3-bg.png"
import { saveItCareerForm } from "../service";
import AWS from "aws-sdk";
import { getawscredentials } from "../service";
import { Modal, ModalManager, Effect } from "react-dynamic-modal";
import { Alert } from "bootstrap";
const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99999999,
    overflow: "hidden",
    perspective: 1300,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
  content: {
    position: "relative",
    margin: "0 auto",
    width: "100%",
    border: "1px solid rgba(0, 0, 0, .2)",
    background: "transparent",
    overflow: "auto",
    borderRadius: "4px",
    outline: "none",
    boxShadow: "0 5px 10px rgba(0, 0, 0, .3)",
    height: "100vh",
  },
};
var s3;
class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerArray: [],
      bannerArrayList: [],
      bannerTitleState: "",
      imageState: "",
      imageNameState: "",
      imageFullFilePath: "",
      file: "",
      imageFileName: "",
      cropImageWidthBanner: 668,
      cropImageHeightBanner: 613,
      cropImageWidthBackgroundImage: 1920,
      cropImageHeightBackgroundImage: 633,
      bannerEditId: "",
      bannerflag: true,
      imageFullFilePath: "",
      file: "",
      imageFileName: "",
      imageFileNameM: "",
      serviceImage1: "",
      imageFullFilePathI: "",
      serviceImagem1: "",
      imageFullFilePathM: "",
      serviceImaget1: "",
      imageFileNameI:"",
      FileM: "",
      FileD : "",
      FileI : "",
      imageFileNameD:"",
      imageFullFilePathD:'',
    }
  }

  componentDidMount() {
    console.log("this.props ===", this.props);
    this.getAwsDetails();
    this.setState({
      bannerContentId: this.props.bannerArray[0].contentDataId,
      bannerArrayList: this.props.bannerArray[0].listing,
    });

    console.log("bannerContentId==", this.state.bannerArrayList);
    if (this.props.bannerArray[0].listing.length > 0) {
      // console.log("serviceArray[0].listing[0].contentDataSubDescription", this.props.serviceArray[0].listing[0].contentDataSubDescription);
      this.setState({
        bannerTitleState: this.props.bannerArray[0].listing[0].contentDataSubTitle,
        imageState: this.props.bannerArray[0].listing[0].image,
        imageNameState: this.props.bannerArray[0].listing[0].imageName
      })
    }
  }


  getAwsDetails() {
    let postData = {
      "functionName": "awsCredentials",
    };
    getawscredentials(postData).then((data) => {
      console.log("decoded", data);
      if (data.data.success === "1") {
        var decoded = data.data.result.s3Details;
        localStorage.setItem("S3BucketMainFolder", decoded.mainFolder);
        localStorage.setItem("Bucket", decoded.s3bucket);

        AWS.config.update({
          accessKeyId: decoded.accessKey,
          secretAccessKey: decoded.secretKey,
          region: "ap-south-1",
        });
        var bucketParams = {
          Bucket: decoded.s3bucket,
        };
        s3 = new AWS.S3({ apiVersion: "2006-03-01", params: bucketParams });

        this.setState(
          {
            s3BucketMainFolder: decoded.mainFolder,
            accessKey: decoded.accessKey,
            secretKey: decoded.secretKey,
            s3bucket: decoded.s3bucket,
          },
          () => {
            // resolve(true);
          }
        );
      } else {
        console.log("error:home:getAwsDetails:", data.errorMessage);
      }
    });
    // });
  }
  saveImageUpload(mode) {
    // debugger
    if(mode==="D"){
    s3.upload(
      {
        Key: this.state.imageFullFilePathD,
        Body: this.state.fileD,
        ACL: "public-read",
      },
      (err, data) => {
        // console.log("err", err);
        if (err) {
          alert("There was an error uploading your photo: ", err.message);
          return null;
        } else {
        }
      }
    );}
    if(mode==="M"){
      s3.upload(
        {
          Key: this.state.imageFullFilePathM,
          Body: this.state.fileM,
          ACL: "public-read",
        },
        (err, data) => {
          // console.log("err", err);
          if (err) {
            alert("There was an error uploading your photo: ", err.message);
            return null;
          } else {
          }
        }
      );}
      if(mode==="I"){
        s3.upload(
          {
            Key: this.state.imageFullFilePathI,
            Body: this.state.fileI,
            ACL: "public-read",
          },
          (err, data) => {
            // console.log("err", err);
            if (err) {
              alert("There was an error uploading your photo: ", err.message);
              return null;
            } else {
            }
          }
        );}
  }

  bannerImageLoad(e, mode,i=null) {
    console.log("hhhhhhhhhhhhhhhh",mode);
    e.preventDefault();
    // debugger
    if (e.target.files[0].size > 2097152) {
        // 2 MiB for bytes.
        alert("File size must be below 2MB!");
        return;
    }
    var fileObj = e.target.files[0];
    let str = fileObj.name;
    var last = str.substring(str.lastIndexOf("/") + 1, str.length);
    let S3BucketMainFolder = localStorage.getItem("S3BucketMainFolder");
    let fileName = "lapa" +Date.now()+ last;
    let reader = new File([fileObj], fileName, {
        type: "image/jpeg",
        lastModified: Date.now(),
    });
    let fullFilePath = S3BucketMainFolder + "/" + fileName;
    this.setState({


    });
    if (mode === "Desktop") {
      console.log("fileName",fileName);
      if(i!=null){
        $('#hidBannerImageName'+i).val(fileName);
      }
      else{
        $('#hidBannerImageName').val(fileName);
      }
        this.setState({
            serviceImage1: window.URL.createObjectURL(e.target.files[0]),
            imageFullFilePathD: fullFilePath,
            imageFileNameD: fileName,
            fileD: reader,
        })
      
    }
    else if (mode === "Mobile") {
      console.log("fileName",fileName);
      if(i!=null){
        $('#hidBannerImageNamet'+i).val(fileName);
      }
      else{
        $('#hidBannerImageNamet').val(fileName);
      }
        this.setState({
            serviceImaget1: window.URL.createObjectURL(e.target.files[0]),
            imageFullFilePathM: fullFilePath,
            imageFileNameM: fileName,
            fileM: reader,
        })
      
    }
    else {
      console.log("fileName",fileName);
      if(i!=null){
        $('#hidBannerImageNamem'+i).val(fileName);
      }
      else{
        $('#hidBannerImageNamem').val(fileName);
      }
        this.setState({
            serviceImagem1: window.URL.createObjectURL(e.target.files[0]),
            imageFullFilePathI: fullFilePath,
            imageFileNameI: fileName,
            fileI: reader,
        })
       
    }
  
}









  save() {

    console.log("serviceImage1 desktop",this.state.serviceImage1);
    console.log("imageFullFilePathD",this.state.imageFullFilePathD);
    console.log("imageFileNameD",this.state.imageFileNameD);
    console.log("fileD",this.state.fileD);
    console.log("serviceImaget1",this.state.serviceImaget1);
    console.log("imageFullFilePathM",this.state.imageFullFilePathM);
    console.log("imageFileNameM",this.state.imageFileNameM);
    console.log("fileM",this.state.fileM);
    console.log("serviceImagem1",this.state.serviceImagem1);
    console.log("imageFullFilePathI",this.state.imageFullFilePathI);
    console.log("imageFileNameI",this.state.imageFileNameI);
    console.log("fileI",this.state.fileI);
    var flag = true
    if ($("#hidBackgroundImageName").val() === '') {
      alert("Upload Background Image")
      return false;
    }
    if ($("#hidBannerImageName").val() === '') {
      alert("Upload Banner Image")
      return false;
    }
    // if ($("#bannerText").val() === '') {
    //   $("#bannerText").focus()
    //   alert("Enter Text")
    //   return false;
    // }
    // if ($("#bannerTextsub").val() === '') {
    //   $("#bannerTextsub").focus()
    //   alert("Enter Text")
    //   return false;
    // }
    if (flag == true) {
      let contentDataId = this.state.bannerContentId
      let bannerText = []
      let bannerTextArray = {
        bannerText: $("#bannerText").val(),
        bannerTextsub: $("#bannerTextsub").val(),
        bannerimgtxt: $("#bannerimgtxt").val(),
        bgBannerimgtxt: $("#bgBannerimgtxt").val(),
        bgBannerimgtxtmb: $("#bgBannerimgtxtmb").val(),
        bannerimgtxtm: $("#bannerimgtxtm").val(),
        bgBannerimgtxttb: $("#bgBannerimgtxttb").val(),
        bannerimgtxtt: $("#bannerimgtxtt").val(),
      }
      bannerText.push(bannerTextArray);
      // let bannerText = $("#bannerText").val()
      // let bannerTextsub = $("#bannerTextsub").val()
      let selectfontStyleData = [];
      let selectfontStyleArray = {
        selectfontfamily: $("#selectfontfamily").val(),
        selectfontsize: $("#selectfontsize").val()
      }
      selectfontStyleData.push(selectfontStyleArray);
      let bgBannerimgtxt = $("#bgBannerimgtxt").val()
      let bannerimgText = $("#bannerimgtxt").val()
      let bgBannerimgtxtmb = $("#bgBannerimgtxtmb").val()
      let bannerimgtxtm = $("#bannerimgtxtm").val()
      let bgBannerimgtxttb = $("#bgBannerimgtxttb").val()
      let bannerimgtxtt = $("#bannerimgtxtt").val()
      let imageName = $("#hidBannerImageName").val()
      let imageNameM = $("#hidBannerImageNamem").val()
      let imageNameT = $("#hidBannerImageNamet").val()
      let backgroundImage = $("#hidBackgroundImageName").val()
      let backgroundImageMb = $("#hidBackgroundImageNamemb").val()
      let backgroundImageTb = $("#hidBackgroundImageNametb").val()
     
      this.saveBanner(
        contentDataId,
        bannerText,
        imageName,
        backgroundImageMb,
        imageNameT,
        imageNameM,
        backgroundImageTb,
        backgroundImage,
        bgBannerimgtxt,
        bannerimgText,
        bgBannerimgtxtmb,
        bannerimgtxtm,
        bgBannerimgtxttb,
        bannerimgtxtt,
        selectfontStyleData,
      );
    }
  }

  saveBanner(
    contentDataId, bannerText, 
    imageName,backgroundImageMb,imageNameT,
    imageNameM,backgroundImageTb, backgroundImage,
    bgBannerimgtxt, bannerimgText,
    bgBannerimgtxtmb,
    bannerimgtxtm,
    bgBannerimgtxttb,
    bannerimgtxtt,
    selectfontStyleData,
  ) {
    const postData = {
      functionName: "saveContentDataSub",
      contentDataId: contentDataId,
      contentDataSubId: "",
      // contentDataSubId: this.state.bannerEditId,
      contentDataSubDescription: JSON.stringify(selectfontStyleData),
      contentDataSubTitle: JSON.stringify(bannerText),
      siteId: "",
      contentDataSubIsApproved: "0",
      image: imageName,
      userRole: "SuperAdmin",
      oldImage: "",
      isSaveDraft: "0",
      contentDataSubSortOrder: "",
      pageId: "1",
     // altText: bgBannerimgtxt,
      //h3Tag: bannerimgText,
      h3Tag: imageNameM,
      hTag: backgroundImageMb,
      contentDataSubSubtitle: backgroundImage,
      text1:imageNameT,
      text2:backgroundImageTb
    };
    if (this.state.imageFileNameD.length > 0) {
      this.saveImageUpload("D");
    }
    if (this.state.imageFileNameM.length > 0) {
      this.saveImageUpload("M");
    }
    if (this.state.imageFileNameI.length > 0) {
      this.saveImageUpload("I");
    }
    console.log("postDataaaa banner", postData);
    // console.log("imageFileName banner = ", this.state.imageFileName);
    // console.log("imageNameState banner = ", this.state.imageNameState);
    saveItCareerForm(postData).then((data) => {
      console.log("hhhhhh.....", data);
      if (data.data.success == 1) {
        this.props.getData()
        this.cancelAboutBanner();
        $("#bannerText").val("");
        $("#bannerTextsub").val("");
        $("#selectfontfamily").val("");
        $("#selectfontsize").val("");
        $("#bgBannerimgtxt").val("");
        $("#bannerimgtxt").val("");
        $("#hidBackgroundImageName").val("");
        $("#hidBannerImageName").val("");
        this.setState({
          bannerflag: true,
        });
      }
    });
  }

  editBannerSave(data, i) {

    console.log("serviceImage1",this.state.serviceImage1);
    console.log("imageFullFilePathD",this.state.imageFullFilePathD);
    console.log("imageFileNameD",this.state.imageFileNameD);
    console.log("fileD",this.state.fileD);
    console.log("serviceImaget1",this.state.serviceImaget1);
    console.log("imageFullFilePathM",this.state.imageFullFilePathM);
    console.log("imageFileNameM",this.state.imageFileNameM);
    console.log("fileM",this.state.fileM);
    console.log("serviceImagem1",this.state.serviceImagem1);
    console.log("imageFullFilePathI",this.state.imageFullFilePathI);
    console.log("imageFileNameI",this.state.imageFileNameI);
    console.log("fileI",this.state.fileI);

    let contentDataId = this.state.bannerContentId
    
   

    let bannerText = []
    let bannerTextArray = {
      bannerText: $("#bannerText" + i).val(),
      bannerTextsub: $("#bannerTextsub" + i).val(),
      bannerimgtxt: $("#bannerimgtxt" + i).val(),
      bgBannerimgtxt: $("#bgBannerimgtxt" + i).val(),
      bgBannerimgtxtmb: $("#bgBannerimgtxtmb" + i).val(),
      bannerimgtxtm: $("#bannerimgtxtm" + i).val(),
      bgBannerimgtxttb: $("#bgBannerimgtxttb" + i).val(),
      bannerimgtxtt: $("#bannerimgtxtt" + i).val(),
    }
    bannerText.push(bannerTextArray);
    //let bgBannerimgtxt = $("#bgBannerimgtxt" + i).val()
    //let bannerimgText = $("#bannerimgtxt" + i).val()
    let imageName = $("#hidBannerImageName" + i).val()
    let backgroundImage = $("#hidBackgroundImageName" + i).val()
    let backgroundImageMb = $("#hidBackgroundImageNameMb" + i).val()
    let backgroundImageTb = $("#hidBackgroundImageNameTb" + i).val()
    let imageNameM = $("#hidBannerImageNamem" + i).val()
    let imageNameT = $("#hidBannerImageNamet" + i).val()
   
    let selectfontStyleData = [];
    let selectfontStyleArray = {
      selectfontfamily: $("#selectfontfamily" + i).val(),
      selectfontsize: $("#selectfontsize" + i).val()
    }
    selectfontStyleData.push(selectfontStyleArray);

    const postData = {
      functionName: "saveContentDataSub",
      contentDataId: contentDataId,
      // contentDataSubId: "",
      contentDataSubId: data.contentDataSubId,
      contentDataSubDescription: JSON.stringify(selectfontStyleData),
      contentDataSubTitle: JSON.stringify(bannerText),
      siteId: "",
      contentDataSubIsApproved: "0",
      image: imageName,
      userRole: "SuperAdmin",
      oldImage: "",
      isSaveDraft: "0",
      contentDataSubSortOrder: "",
      pageId: "1",
      //altText:,
     // rejectComment: JSON.stringify(selectAlttextData),
     // h3Tag: bannerimgText,
     h3Tag: imageNameM,
     hTag: backgroundImageMb,
      contentDataSubSubtitle: backgroundImage,
      //text3:imageSelectName
      text1:imageNameT,
      text2:backgroundImageTb
    };

    console.log("editpostDataaaa banner", postData);
    // console.log("imageFileName banner = ", this.state.imageFileName);
    // console.log("imageNameState banner = ", this.state.imageNameState);
    saveItCareerForm(postData).then((data) => {
      console.log("hhhhhh.....", data);
      if (data.data.success == 1) {
        this.props.getData()
        this.cancelAboutBanner(i);
        // $("#bannerText").val("");
        // $("#bgBannerimgtxt").val("");
        // $("#bannerimgtxt").val("");
        // $("#hidBackgroundImageName").val("");
        // $("#hidBannerImageName").val("");
        this.setState({
          bannerflag: true,
          serviceImage: "",
          serviceImage1: "",
          serviceImagem: "",
          serviceImagem1: "",
          serviceImaget: "",
          serviceImaget1: "",
        });
        this.slider.slickPlay();
      }
    });

  }

//desktop
  // bannerImageLoad(e, fileId, fileOutput, cropSuccessId, imageFrom) {
  //   //console.log("e"+e);console.log("fileId"+fileId);console.log("fileOutput"+fileOutput);console.log("cropSuccessId"+cropSuccessId);console.log("imageFrom"+imageFrom);
  //   this.setState({
  //     type: e.target.files[0].name.split(".").pop(),
  //   });
  //   if (
  //     e.target.files[0].name.split(".").pop() != "jpg" &&
  //     e.target.files[0].name.split(".").pop() != "JPG" &&
  //     e.target.files[0].name.split(".").pop() != "png" &&
  //     e.target.files[0].name.split(".").pop() != "PNG"
  //   ) {
  //     alert("Please Upload jpg or png image");
  //     return false;
  //   }
  //   e.preventDefault();
  //   var fileObj = e.target.files[0];
  //   this.setState(
  //     {
  //       cropImageUrl: window.URL.createObjectURL(fileObj),
  //     },
  //     () => {
  //       this.cropPopup(fileId, fileOutput, cropSuccessId, imageFrom);
  //     }
  //   );


  //   if (fileId === "uploadBackground")
  //     this.setState({
  //       serviceImage: window.URL.createObjectURL(e.target.files[0]),
  //     });
  //   else {
  //     this.setState({
  //       serviceImage1: window.URL.createObjectURL(e.target.files[0]),
  //     });
  //   }
  // }

//mobile
// bannerImageLoadm(e, fileId, fileOutput, cropSuccessId, imageFrom) {
//  // console.log("e"+e);console.log("fileId"+fileId);console.log("fileOutput"+fileOutput);console.log("cropSuccessId"+cropSuccessId);console.log("imageFrom"+imageFrom);
//   this.setState({
//     type: e.target.files[0].name.split(".").pop(),
//   });
//   if (
//     e.target.files[0].name.split(".").pop() != "jpg" &&
//     e.target.files[0].name.split(".").pop() != "JPG" &&
//     e.target.files[0].name.split(".").pop() != "png" &&
//     e.target.files[0].name.split(".").pop() != "PNG"
//   ) {
//     alert("Please Upload jpg or png image");
//     return false;
//   }
//   e.preventDefault();
//   var fileObj = e.target.files[0];
//   this.setState(
//     {
//       cropImageUrl: window.URL.createObjectURL(fileObj),
//     },
//     () => {
//       this.cropPopup(fileId, fileOutput, cropSuccessId, imageFrom);
//     }
//   );


//   if (fileId === "uploadBackground")
//     this.setState({
//       serviceImagem: window.URL.createObjectURL(e.target.files[0]),
//     });
//   else {
//     this.setState({
//       serviceImagem1: window.URL.createObjectURL(e.target.files[0]),
//     });
//   }
// }

//tab
// bannerImageLoadt(e, fileId, fileOutput, cropSuccessId, imageFrom) {
//   //console.log("e"+e);console.log("fileId"+fileId);console.log("fileOutput"+fileOutput);console.log("cropSuccessId"+cropSuccessId);console.log("imageFrom"+imageFrom);
//   this.setState({
//     type: e.target.files[0].name.split(".").pop(),
//   });
//   if (
//     e.target.files[0].name.split(".").pop() != "jpg" &&
//     e.target.files[0].name.split(".").pop() != "JPG" &&
//     e.target.files[0].name.split(".").pop() != "png" &&
//     e.target.files[0].name.split(".").pop() != "PNG"
//   ) {
//     alert("Please Upload jpg or png image");
//     return false;
//   }
//   e.preventDefault();
//   var fileObj = e.target.files[0];
//   this.setState(
//     {
//       cropImageUrl: window.URL.createObjectURL(fileObj),
//     },
//     () => {
//       this.cropPopup(fileId, fileOutput, cropSuccessId, imageFrom);
//     }
//   );


//   if (fileId === "uploadBackground")
//     this.setState({
//       serviceImaget: window.URL.createObjectURL(e.target.files[0]),
//     });
//   else {
//     this.setState({
//       serviceImaget1: window.URL.createObjectURL(e.target.files[0]),
//     });
//   }
// }

  deleteBanner(deleteId) {
    const postData = {
      functionName: "delete",
      contentDataSubId: deleteId,
    };
    if (window.confirm("Do you want to delete?")) {
      saveItCareerForm(postData).then((data) => {
        if (data.data.success == 1) {
          this.props.getData();
          window.location.reload();
        }
      });
    } else {
      return false;
    }
  }


  // cropPopup(fileId, fileOutput, cropSuccessId, imageFrom) {
  //   ModalManager.open(
  //     <Modal onRequestClose={true} style={customStyles} effect={Effect.Fall}>
  //       <CropSection
  //         type={this.state.type}
  //         cropImageUrl={this.state.cropImageUrl}
  //         cropImageWidth={
  //           imageFrom === "BackgroundImage"
  //             ? this.state.cropImageWidthBackgroundImage
  //             : imageFrom === "Banner"
  //               ? this.state.cropImageWidthBanner
  //               : this.state.cropImageWidthBackgroundImage
  //         }
  //         cropImageHeight={
  //           imageFrom === "BackgroundImage"
  //             ? this.state.cropImageHeightBackgroundImage
  //             : imageFrom === "Banner"
  //               ? this.state.cropImageHeightBanner
  //               : this.state.cropImageHeightBackgroundImage
  //         }
  //         accessKey={this.props.accessKey}
  //         secretKey={this.props.secretKey}
  //         successInput={cropSuccessId}
  //         fileId={fileId}
  //         fileOutput={fileOutput}
  //         cropPopupClose={this.cropPopupClose}
  //         cropDone={this.cropDone}
  //       ></CropSection>
  //     </Modal>
  //   );
  // }

  // cropPopupClose(fileId) {
  //   ModalManager.close();
  //   $("#" + fileId).val(null);
  // }
  // cropDone(cropDoneUrl, fileOutput, fileId) {
  //   $("#" + fileOutput).val(cropDoneUrl);
  //   $("#" + fileId).val(null);

  // }

  

  editBanner(data, editId) {
    $(".banner-editsection" + editId).addClass("editActive");
    // if (this.props.bannerArray[0].listing.length > 0) {
    // document.getElementById("#bannerText" + editId).value = data.contentDataSubTitle
    $("#bannerText" + editId).val(JSON.parse(data.contentDataSubTitle)[0].bannerText);
    $("#bannerTextsub" + editId).val(JSON.parse(data.contentDataSubTitle)[0].bannerTextsub);
    //$("#bgBannerimgtxt" + editId).val(data.altText);
    $("#bannerimgtxt" + editId).val(data.h3Tag);
    $("#hidBackgroundImageName" + editId).val(data.contentDataSubSubtitle);
    $("#hidBannerImageName" + editId).val(data.imageName);
    $("#hidBannerImageNamem" + editId).val(data.h3Tag);
    $("#hidBannerImageNamet" + editId).val(data.text1);
    $("#selectfontfamily" + editId).val(JSON.parse(data.contentDataSubDescription)[0].selectfontfamily);
    $("#selectfontsize" + editId).val(JSON.parse(data.contentDataSubDescription)[0].selectfontsize);
    $("#bgBannerimgtxt"+ editId).val(JSON.parse(data.contentDataSubTitle)[0].bgBannerimgtxt);
    $("#bannerimgtxt"+ editId).val(JSON.parse(data.contentDataSubTitle)[0].bannerimgtxt);
    $("#bgBannerimgtxtmb"+ editId).val(JSON.parse(data.contentDataSubTitle)[0].bgBannerimgtxtmb);
    $("#bannerimgtxtm"+ editId).val(JSON.parse(data.contentDataSubTitle)[0].bannerimgtxtm);
    $("#bgBannerimgtxttb"+ editId).val(JSON.parse(data.contentDataSubTitle)[0].bgBannerimgtxttb);
    $("#bannerimgtxtt"+ editId).val(JSON.parse(data.contentDataSubTitle)[0].bannerimgtxtt);


    // }
    this.setState({
      bannerEditId: editId,
      bannerflag: false,
    });
    this.slider.slickPause();
  }



  AddAboutBanner() {
    $("#banneradd-section").addClass("editActive");
  }
  cancelAboutBanner(i) {
    $("#banneradd-section").removeClass("editActive");
    $(".banner-editsection" + i).removeClass("editActive");
    this.setState({
      bannerflag: true,
      serviceImage: "",
      serviceImage1: "",
      serviceImagem: "",
      serviceImagem1: "",
      serviceImaget: "",
      serviceImaget1: "",
    });
    this.slider.slickPlay();
  }
  render() {
    var bannerSettings = {
      dots: true,
      infinite: ((localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") ? false : true),
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
     // autoplay: true,
      swipe: true
    };
    return (
      <div className="banner">
        <header className="headerSection">
          <div className="logo_blackbg">
            <a href='https://www.lakme-academy.com/'>
              <img src={Logo} className="logo logo-display lakme-logo" alt="Lakmé Academy Powered by Aptech" />
            </a>
          </div>
        </header>
        <div id="banneradd-section">
          <div className="edit-banner-section edit-banner-section-paddtop">
            <input type="text" className="editInput" id="bannerText" placeholder="Enter Text" style={{ width: "850px" }} />
            <input type="text" className="editInput" id="bannerTextsub" placeholder="Enter Sub Text" style={{ width: "850px" }} />
            <div className="selectfont_bannerdiv">
              <select name="" id="selectfontfamily" className="editInput" style={{ width: "410px" }}>
                <option value="0">Select Font Family</option>
                <option value="Scarecrow-Regular">Scarecrow-Regular</option>
                <option value="neo">neo</option>
                <option value="matao">matao</option>
              </select>
              <select name="" id="selectfontsize" className="editInput" style={{ width: "410px" }}>
                <option value="0">Select Font size</option>
                <option value="60px">60px</option>
                <option value="54px">54px</option>
                <option value="48px">48px</option>
              </select>
            </div>
            <div className="imageEditListBanner">
              {/* <div className="banner-uploadbannerdiv">
                <span className="fileUpload">
                  <input type="file" id="fileUploadBackgroundAdd" accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoad(e, "uploadBackground",
                    "hidBackgroundImageName",
                    "backgroundCropSuccess",
                    "background")} />
                  <input type="hidden" id="hidBackgroundImageName" />
                  <label for="fileUploadBackgroundAdd">Upload Background Image</label>
                  <span className="bannerImageAlert">
                    <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                    <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                    <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                    <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                  </span>
                </span> */}
                {/* {console.log("this.state.contentDataSubSubtitle=", this.state.contentDataSubSubtitle)} */}

                {/* <div className="text-center mb-3">
                  {this.state.serviceImage ? <img src={this.state.serviceImage} style={{ width: "25%", height: "50px" }} /> : ""}
                </div>

                <input type="text" className="editInput" id="bgBannerimgtxt" placeholder="Enter alt Text" />
              </div> */}
              <div className="banner-uploadbannerdiv">
                <span className="fileUpload">

                  <input type="file" id="fileUploadBannerAdd" accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoad(e, "Desktop", null
                    // "hidBannerImageName",
                    // "bannerCropSuccess",
                    // "Banner"
                    )} />
                  <input type="hidden" id="hidBannerImageName" />
                  <label for="fileUploadBannerAdd">Upload Desktop Banner</label>
                  <span className="bannerImageAlert">
                    <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                    <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                    <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                    <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                  </span>

                </span>
                <div className="text-center mb-3">
                  {this.state.serviceImage1 ? <img src={this.state.serviceImage1} style={{ width: "25%", height: "50px" }} /> : ""}
                </div>

                {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                <input type="text" className="editInput" id="bannerimgtxt" placeholder="Enter alt Text" />
              </div>

              {/* <div className="banner-uploadbannerdiv mobile">
                <span className="fileUpload">
                  <input type="file" id="fileUploadBackgroundAdd_mb" accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoadm(e, "uploadBackground",
                    "hidBackgroundImageNamemb",
                    "backgroundCropSuccess_mb",
                    "background_mb")} />
                  <input type="hidden" id="hidBackgroundImageNamemb" />
                  <label for="fileUploadBackgroundAdd_mb">Upload Background Image</label>
                  <span className="bannerImageAlert">
                    <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                    <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                    <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                    <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                  </span>
                </span> */}
                {/* {console.log("this.state.contentDataSubSubtitle=", this.state.contentDataSubSubtitle)} */}

                {/* <div className="text-center mb-3"> */}
                  {/* {console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", this.props.bannerArray[0].listing[0].imagePath + this.state.contentDataSubSubtitle)} */}
                  {/* {this.state.serviceImagem ? <img src={this.state.serviceImagem} style={{ width: "25%", height: "50px" }} /> : ""} */}
                {/* </div> */}

                {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                {/* <input type="text" className="editInput" id="bgBannerimgtxtmb" placeholder="Enter alt Text" /> */}
              {/* </div> */}
              <div className="banner-uploadbannerdiv mobile">
                <span className="fileUpload">

                  <input type="file" id="fileUploadBannerAddm" accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoad(e, "Tab",
                  null  // "hidBannerImageNamem",
                    // "bannerCropSuccess",
                    // "Banner"
                    )} />
                  <input type="hidden" id="hidBannerImageNamem" />
                  <label for="fileUploadBannerAddm">Upload Tab Banner</label>
                  <span className="bannerImageAlert">
                    <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                    <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                    <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                    <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                  </span>

                </span>
                <div className="text-center mb-3">
                  {this.state.serviceImagem1 ? <img src={this.state.serviceImagem1} style={{ width: "25%", height: "50px" }} /> : ""}
                </div>

                {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                <input type="text" className="editInput" id="bannerimgtxtm" placeholder="Enter alt Text" />
              </div>

              {/* <div className="banner-uploadbannerdiv tab"> */}
                {/* <span className="fileUpload">
                  <input type="file" id="fileUploadBackgroundAdd_tb" accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoadt(e, "uploadBackground",
                    "hidBackgroundImageNametb",
                    "backgroundCropSuccess_tb",
                    "background")} />
                  <input type="hidden" id="hidBackgroundImageNametb" />
                  <label for="fileUploadBackgroundAdd_tb">Upload Background Image</label>
                  <span className="bannerImageAlert">
                    <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                    <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                    <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                    <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                  </span>
                </span> */}
                {/* {console.log("this.state.contentDataSubSubtitle=", this.state.contentDataSubSubtitle)} */}

                {/* <div className="text-center mb-3"> */}
                  {/* {console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", this.props.bannerArray[0].listing[0].imagePath + this.state.contentDataSubSubtitle)} */}
                  {/* {this.state.serviceImaget ? <img src={this.state.serviceImaget} style={{ width: "25%", height: "50px" }} /> : ""} */}
                {/* </div> */}

                {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                {/* <input type="text" className="editInput" id="bgBannerimgtxttb" placeholder="Enter alt Text" /> */}
              {/* </div> */}
              <div className="banner-uploadbannerdiv tab">
                <span className="fileUpload">

                  <input type="file" id="fileUploadBannerAddt" accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoad(e, "Mobile", null
                    // "hidBannerImageNamet",
                    // "bannerCropSuccess",
                    // "Banner"
                    )} />
                  <input type="hidden" id="hidBannerImageNamet" />
                  <label for="fileUploadBannerAddt">Upload Mobile Banner</label>
                  <span className="bannerImageAlert">
                    <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                    <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                    <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                    <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                  </span>

                </span>
                <div className="text-center mb-3">
                  {this.state.serviceImaget1 ? <img src={this.state.serviceImaget1} style={{ width: "25%", height: "50px" }} /> : ""}
                </div>

                {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                <input type="text" className="editInput" id="bannerimgtxtt" placeholder="Enter alt Text" />
              </div>

            </div>


            {/* <input type="number" className="editInput" id={"sortBannerUpdate"} placeholder="Sort Order" /> */}
            <div className="editPanelButton">

              {/* <span className="saveButton saveDraft" onClick={(e) => { this.save("DRAFT") }}>Save Draft</span> */}
              <span className="saveButton" id={"submitBanner"} onClick={() => { this.save() }}>Submit</span>
              <span className="cancelButton" onClick={(e) => { this.cancelAboutBanner() }}>Cancel</span>
            </div>
          </div>
        </div>
        <div className="banner-editsectionwrpr">
          <Slider ref={slider => (this.slider = slider)} {...bannerSettings}>
            {this.props.bannerArray[0].listing.map((data, i) => (
              <div key={i} className={"banner-editsecoutr banner-editsection" + i} id="banner-editsection">
               
                <section className="text-rotator" style={{overflow:'auto'}}>
                   {/* <img src={data.imagePath + data.contentDataSubSubtitle} alt={data.altText.bgBannerimgtxt} className="text-rotator" /> */}
                   <img src={data.image} alt={data.imageName} className="text-rotator desk_banner"   />
                      <img src={data.imagePath + data.h3Tag} alt={data.h3Tag} className="w-100 tab_banner" />
                     <img src={data.imagePath + data.text1} alt={data.text1} className="w-100 mobile_banner" /> 
                  <div className="text-rotator1">
                    <div class="banner-contents">
                     <h1 class="banner-content_text" style={{fontFamily:JSON.parse(data.contentDataSubDescription)[0].selectfontfamily}}>
                       <span class="desk_banner"> {JSON.parse(data.contentDataSubTitle)[0].bannerText}</span>
                       <span class="mobile_banner">{JSON.parse(data.contentDataSubTitle)[0].bgBannerimgtxttb}</span>
                      <span class="banner_sub_text">{JSON.parse(data.contentDataSubTitle)[0].bannerTextsub}</span>
                     </h1>
                   </div>
                   {/* <div className="banner_girl_img"> 
                     <img src={data.image} alt={data.imageName} className="banner_girlimg desk_banner" />
                     <img src={data.imagePath + data.h3Tag} alt={data.h3Tag} className="banner_girlimg mobile_banner" />
                     <img src={data.imagePath + data.text1} alt={data.text1} className="banner_girlimg mobile_banner" />
                   </div> */}
                  </div>
                 
                 
                  {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
                    <>
                      <div className="adminIconMain adminIconMain_banner">

                        <span
                          class="editIcon editButton"
                          id={"edit-btn" + i}
                          onClick={(e) => {
                            this.editBanner(data, i);
                          }}
                        >
                          <img src={Edit} />
                        </span>
                        {/* <span class="editIcon lockButton"><img src={lock} /></span> */}
                        <span class="editIcon DeleteIcon" onClick={() => this.deleteBanner(data.contentDataSubId)}>
                          <img src={Delete} />
                        </span>
                      </div>
                    </>
                  }
                  <div className={"edit-banner-section edit-banner-section-paddtop"} style={{overflow:'auto',height:'100%'}}>
                    {/* {console.log(".............................................banere", data, i)} */}
                    <input type="text" className="editInput" id={"bannerText" + i} placeholder="Enter Text" style={{ width: "850px" }} />
                    <input type="text" className="editInput" id={"bannerTextsub" + i} placeholder="Enter Sub Text" style={{ width: "850px" }} />
                    <div className="selectfont_bannerdiv">
                      <select name="" id={"selectfontfamily" + i} className="editInput" style={{ width: "410px" }}>
                        <option value="0">Select Font Family</option>
                        <option value="Scarecrow-Regular">Scarecrow-Regular</option>
                        <option value="neo">neo</option>
                        <option value="matao">matao</option>
                      </select>
                      <select name="" id={"selectfontsize" + i} className="editInput" style={{ width: "410px" }}>
                        <option value="0">Select Font size</option>
                        <option value="60px">60px</option>
                        <option value="54px">54px</option>
                        <option value="48px">48px</option>
                      </select>
                    </div>
                    <div className={"imageEditListBanner"}>
                      {/* <div className="banner-uploadbannerdiv">
                        <span className="fileUpload">
                          <input type="file" id={"fileUploadBackgroundAdd" + i} accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoad(e, "uploadBackground",
                            "hidBackgroundImageName" + i,
                            "backgroundCropSuccess",
                            "background")} />
                          <input type="hidden" id={"hidBackgroundImageName" + i} />
                          <label for={"fileUploadBackgroundAdd" + i}>Upload Background Image</label>
                          <span className="bannerImageAlert">
                            <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                            <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                            <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                            <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                          </span>
                        </span> */}
                        {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                        {/* <div className="text-center mb-3">
                          

                          {this.state.serviceImage ? <img src={this.state.serviceImage} style={{ width: "26%", height: "50px", margin: "0 auto" }} /> : <img src={data.imagePath + data.contentDataSubSubtitle} style={{ width: "20%", height: "50px", margin: "0 auto" }} />}
                        </div>
                        <input type="text" className="editInput" id={"bgBannerimgtxt" + i} placeholder="Enter alt Text" />
                      </div> */}
                      <div className="banner-uploadbannerdiv">
                        <span className="fileUpload">
                          <input type="file" id={"fileUploadBannerAdd" + i} accept="image/png,image/jpeg" 
                          onChange={(e) => this.bannerImageLoad(e, "Desktop" ,i
                          // + i,
                          //   "hidBannerImageName" + i,
                          //   "bannerCropSuccess",
                          //   "Banner"
                            )} />
                          <input type="hidden" id={"hidBannerImageName" + i} />
                          <label for={"fileUploadBannerAdd" + i}>Upload Desktop Banner</label>
                          <span className="bannerImageAlert">
                            <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                            <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                            <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                            <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                          </span>
                        </span>
                        <div className="text-center mb-3 d">
                          {this.state.serviceImage1 ? <img src={this.state.serviceImage1} style={{ width: "25%", height: "50px", margin: "0 auto" }} /> : <img src={data.image} style={{ width: "25%", height: "50px", margin: "0 auto" }} />}
                        </div>
                        <input type="text" className="editInput" id={"bannerimgtxt" + i} placeholder="Enter alt Text" />
                      </div>
                    </div>
                    
                    <div className={"imageEditListBanner"}>
                      {/* <div className="banner-uploadbannerdiv">
                        <span className="fileUpload">
                          <input type="file" id={"fileUploadBackgroundAdd_mb" + i} accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoadm(e, "uploadBackground",
                            "hidBackgroundImageNamemb" + i,
                            "backgroundCropSuccess",
                            "background")} />
                          <input type="hidden" id={"hidBackgroundImageNamemb" + i} />
                          <label for={"fileUploadBackgroundAdd_mb" + i}>Upload Background Image</label>
                          <span className="bannerImageAlert">
                            <span className="bannerSizeText"><strong>Format:</strong> jpeg or png </span>
                            <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                            <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                            <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                          </span>
                        </span> */}
                        {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                        {/* <div className="text-center mb-3">
                          {this.state.serviceImagem ? <img src={this.state.serviceImagem} style={{ width: "25%", height: "50px", margin: "0 auto" }} /> : <img src={data.imagePath + data.hTag} style={{ width: "25%", height: "50px", margin: "0 auto" }} />}
                        </div>
                        <input type="text" className="editInput" id={"bgBannerimgtxtmb" + i} placeholder="Enter alt Text" />
                      </div> */}
                      <div className="banner-uploadbannerdiv">
                        <span className="fileUpload">
                          <input type="file" id={"fileUploadBannerAddm" + i} accept="image/png,image/jpeg" 
                          onChange={(e) => this.bannerImageLoad(e, "Tab",i
                              //+1,
                            // "hidBannerImageNamem" + i,
                            // "bannerCropSuccess",
                            // "Banner"
                            )} />
                          <input type="hidden" id={"hidBannerImageNamem" + i} />
                          <label for={"fileUploadBannerAddm" + i}>Upload Tab Banner</label>
                          <span className="bannerImageAlert">
                            <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                            <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                            <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                            <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                          </span>
                        </span>
                        <div className="text-center mb-3 t">
                          {this.state.serviceImagem1 ? <img src={this.state.serviceImagem1} style={{ width: "25%", height: "50px", margin: "0 auto" }} /> : <img src={data.imagePath + data.h3Tag} style={{ width: "25%", height: "50px", margin: "0 auto" }} />}
                        </div>
                        <input type="text" className="editInput" id={"bannerimgtxtm" + i} placeholder="Enter alt Text" />
                      </div>
                    </div>

                    
                    <div className={"imageEditListBanner"}>
                      {/* <div className="banner-uploadbannerdiv">
                        <span className="fileUpload">
                          <input type="file" id={"fileUploadBackgroundAdd_tb" + i} accept="image/png,image/jpeg" onChange={(e) => this.bannerImageLoadt(e, "uploadBackground",
                            "hidBackgroundImageNametb" + i,
                            "backgroundCropSuccess",
                            "background")} />
                          <input type="hidden" id={"hidBackgroundImageNametb" + i} />
                          <label for={"fileUploadBackgroundAdd_tb" + i}>Upload Background Image</label>
                          <span className="bannerImageAlert">
                            <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                            <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                            <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                            <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                          </span>
                        </span> */}
                        {/* <img className="imgPreview-banner" src={BannerImg} /> */}
                        {/* <div className="text-center mb-3">
                          {this.state.serviceImaget ? <img src={this.state.serviceImaget} style={{ width: "25%", height: "50px", margin: "0 auto" }} /> : <img src={data.imagePath + data.text2} style={{ width: "25%", height: "50px", margin: "0 auto" }} />}
                        </div>
                        <input type="text" className="editInput" id={"bgBannerimgtxtttb" + i} placeholder="Enter alt Text" />
                      </div> */}
                      <div className="banner-uploadbannerdiv">
                        <span className="fileUpload">
                          <input type="file" id={"fileUploadBannerAddt" + i} accept="image/png,image/jpeg"
                           onChange={(e) => this.bannerImageLoad(e, "Mobile",i
                            // + i,
                            // "hidBannerImageNamet" + i,
                            // "bannerCropSuccess",
                            // "Banner"
                            )} />
                          <input type="hidden" id={"hidBannerImageNamet" + i} />
                          <label for={"fileUploadBannerAddt" + i}>Upload Mobile Banner</label>
                          <span className="bannerImageAlert">
                            <span className="bannerSizeText"><strong>Format:</strong> jpeg or png</span>
                            <span className="bannerSizeText"><strong>Size:</strong> less than 1Mb</span>
                            <span className="bannerSizeText"><strong>Dimension:</strong> 1162*669 px</span>
                            <span className="bannerTextAlert">Please make sure your uploaded media is in jpeg or png format and less than 1 MB and 1162*669 px photo size</span>
                          </span>
                        </span>
                        <div className="text-center mb-3 m">
                          {this.state.serviceImaget1 ? <img src={this.state.serviceImaget1} style={{ width: "25%", height: "50px", margin: "0 auto" }} /> : <img src={data.imagePath + data.text1} style={{ width: "25%", height: "50px", margin: "0 auto" }} />}
                        </div>
                        <input type="text" className="editInput" id={"bannerimgtxtt" + i} placeholder="Enter alt Text" />
                      </div>
                    </div>
                    {/* <input type="number" className="editInput" id={"sortBannerUpdate"} placeholder="Sort Order" /> */}
                    <div className="editPanelButton m-0">

                      {/* <span className="saveButton saveDraft" onClick={(e) => { this.save("DRAFT") }}>Save Draft</span> */}
                      <span className="saveButton" id={"submitBanner"} onClick={() => { this.editBannerSave(data, i) }}>Submit</span>
                      <span className="cancelButton" onClick={(e) => { this.cancelAboutBanner(i) }}>Cancel</span>
                    </div>
                  </div>
                </section>

              </div>
            ))}

          </Slider>
        </div>

        <div className="editSection">

        </div>
        {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&

          <>
            {this.state.bannerflag === true ?
              <div className="adminIconMain">
                <span
                  className="editIcon addButton"
                  onClick={(e) => {
                    this.AddAboutBanner();
                  }}
                >
                  <img src={Add} />
                </span>
              </div>
              : ""}
          </>

        }


        {this.state.bannerflag === true ?
          <Form fromPage={"home"} />
          : ""}
      </div>
    );
  }
}
export default Banner;
